import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import addNotification from '~/utils/toast'

import {
  actUpdateWorkScheduleFailed,
  actUpdateWorkScheduleSuccess,
  MASTER_UPDATE_WORK_SCHEDULE,
} from '../../actions/work-schedule'
import { apiUpdateWorkSchedule } from '../../apis/work-schedule'

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doUpdate(action) {
  try {
    const response = yield call(apiUpdateWorkSchedule, action?.payload)

    if (response?.statusCode === 200) {
      yield put(actUpdateWorkScheduleSuccess({ data: response.data }))
      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      }
    } else {
      addNotification(response?.message, NOTIFICATION_TYPE.ERROR)
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(actUpdateWorkScheduleFailed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchUpdate() {
  yield takeLatest(MASTER_UPDATE_WORK_SCHEDULE, doUpdate)
}
